// @ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../../const/ApiEndPoints';

export default function useAttribute() {
  const setDraftAttributeValue = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.SAVE_DRAFT}`,
        body,
        {
          loader: false,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getDraftAttributeValue = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.SAVE_DRAFT}`,
        {
          params: body,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getAttributeDetails = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.ATTRIBUTE_DETAILS}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getHtmlAttributeValue = (body, loader = false) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_HTML_ATTRIBUTE_VALUE}`,
        body,
        { loader }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };
  const getFieldsDataTypes = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_FIELDS_DATA_TYPES}`,
        {
          params: body,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getMappedData = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_MAPPED_VALUES}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const uploadFileForAttribute = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.UPLOAD_FILE_FOR_ATTRIBUTE}`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateFileAttributes = (payload) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.UPLOAD_FILE_FOR_ATTRIBUTE}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getAttributeSourceMapping = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ATTRIBUTE_SOURCE_MAPPING}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getCalculationRelationAttribute = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_CALCULATION_RELATED_ATTRIBUTES}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getOverrideAttributeValue = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_OVERRIDE_ATTRIBUTE_VALUE}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const calculateAttributeValue = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CALCULATE_ATTRIBUTE_VALUE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const overrideAttributeValue = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.OVERRIDE_ATTRIBUTE_VALUE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getConstraintSources = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CONSTRAINT_SOURCES}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getConstraints = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_CONSTRAINTS}`,
        body,
        {
          loader: false,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getAssociationAttributesData = (body, loader = false) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ASSOCIATION_ATTRIBUTES_DATA}`,
        body,
        {
          loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const saveModelComments = (body, loader = false) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.NOTES.COMMENTS}`,
        body,
        {
          loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getUsersAttributesData = (body, loader = false) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_USERS_ATTRIBUTES_DATA}`,
        body,
        {
          loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  /**
   * Calculate derived column values for a single row in a config-column AdvancedTable.
   * POST /vault/advanced-table/calculate-row/
   */
  const calculateAdvancedTableRow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CALCULATE_ADV_TABLE_ROW}`,
        body,
        { loader: false }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };

  /**
   * Get column-level constraints for a config-column AdvancedTable based on current row values.
   * POST /vault/advanced-table/get-column-constraints/
   */
  const getAdvancedTableColumnConstraints = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ADV_TABLE_COLUMN_CONSTRAINTS}`,
        body,
        { loader: false }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };

  /**
   * Get table constraint sources for an AdvancedTable attribute.
   * GET /vault/get-adv-constraint-sources/
   */
  const getAdvancedTableConstraintSources = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ADV_TABLE_CONSTRAINT_SOURCES}`,
        { params, loader: false }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };

  /**
   * Precheck if an advanced table can be accessed (e.g. column ordering not in progress).
   * GET /vault/precheck-advanced-table
   */
  const precheckAdvancedTable = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.PRECHECK_ADVANCED_TABLE}`,
        { params, loader: true }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };

  return {
    getAttributeDetails,
    setDraftAttributeValue,
    getDraftAttributeValue,
    getFieldsDataTypes,
    getMappedData,
    uploadFileForAttribute,
    updateFileAttributes,
    getAttributeSourceMapping,
    getCalculationRelationAttribute,
    getOverrideAttributeValue,
    calculateAttributeValue,
    overrideAttributeValue,
    getConstraintSources,
    getConstraints,
    getAssociationAttributesData,
    saveModelComments,
    getUsersAttributesData,
    calculateAdvancedTableRow,
    getAdvancedTableColumnConstraints,
    getAdvancedTableConstraintSources,
    precheckAdvancedTable,
    getHtmlAttributeValue,
  };
}
